import React, { FC, useMemo } from 'react';
import { Link } from '@getgo/chameleon-web/react';

const emailPattern = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
const urlPattern =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&=]*)/g;

const textToLink = (text: string) => {
  // add prefix https if not present
  const strHref = text.match(/^(http(s)?:\/\/)/) ? text : `https://${text}`;
  return (
    <Link key={text} variant={'body-small' as any} target="_blank" href={strHref}>
      {text}
    </Link>
  );
};

const textToMailLink = (emailText: string) => {
  return (
    <>
      {emailText.split(emailPattern).map((text, index) =>
        emailPattern.test(text) ? (
          <Link key={index} variant={'body-small' as any} href={`mailto:${text}`}>
            {text}
          </Link>
        ) : (
          text
        ),
      )}
    </>
  );
};

const splitStrUrl = (text = '') => {
  if (!urlPattern.test(text)) return text;
  const description = text.replace(/\n/g, ' \n ');

  // Split on spaces and commas, but keep the delimiter (comma) in the result
  const tokens = description.split(/([, ]+)/);

  return tokens.reduce((arr: any[], current: string) => {
    // Skip empty tokens
    if (!current) return arr;

    // If token is just a delimiter (comma, space, etc.), add as is
    if (/^[, ]+$/.test(current)) {
      return [...arr, current];
    }

    // Remove trailing punctuation for URL/email detection
    const match = current.match(/^(.+?)([.;:!?)]*)$/);
    const mainPart = match ? match[1] : current;
    const trailing = match ? match[2] : '';

    let ele: string | JSX.Element = current;
    if (mainPart.match(emailPattern)) {
      ele = (
        <>
          {textToMailLink(mainPart)}
          {trailing}
        </>
      );
    } else if (mainPart.match(urlPattern)) {
      ele = (
        <>
          {textToLink(mainPart)}
          {trailing}
        </>
      );
    } else {
      ele = current;
    }
    if (ele === '\n') {
      return [...arr, ele];
    }
    return [...arr, ele];
  }, []);
};

const FormatStringUrl: FC = ({ children }) => {
  const formatStringMemo = useMemo(() => splitStrUrl(String(children)), [children]);

  if (children) return <>{formatStringMemo}</>;
  return null;
};

export default FormatStringUrl;
